import {memo, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router';
import {batchActions} from 'redux-batched-actions';

import loadJS from '@neonaut/lib-js/es/dom/network/load-js';
// import {trackPageView} from '@neonaut/lib-js/es/misc/piwik';
import {setDocumentLanguage, translate} from '@mapsight/ui/src/js/helpers/i18n';


import {async} from '@mapsight/core/lib/base/actions';
import {load} from '@mapsight/core/lib/feature-sources/actions';


import {titleSelector, viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {FEATURE_SELECTIONS, FEATURE_SOURCES} from '@mapsight/ui/src/js/config/constants/controllers';
import {VIEW_DESKTOP, VIEW_FULLSCREEN, VIEW_MAP_ONLY, VIEW_MOBILE} from '@mapsight/ui/src/js/config/constants/app';
import {
	setAppTitle,
	setListIsVisible,
	setListScrollOnPreselection,
	setListSelectionBehaviorSelection,
	setMapVisible,
	setOverlayModalVisible,
	setView,
} from '@mapsight/ui/src/js/store/actions';
import {FEATURE_SELECTION_PRESELECT, FEATURE_SELECTION_SELECT} from '@mapsight/ui/src/js/config/feature/selections';

import {setLanguageOpen, setNavigationOpen} from '../../stade/store/actions';
import {deselectAllFromRoute, selectExclusivelyFromRoute, setListFeatureSource, setListVisible} from '../store/actions';

import {useMagic} from '../../hooks';
import {navPosition} from './nav-pos';
import {KINDER_POI_URI} from '../config/feature-sources';


function viewIfMap(isMap, currentView) {
	if(isMap) {
		return (currentView === VIEW_DESKTOP || currentView ===  VIEW_FULLSCREEN) ? VIEW_FULLSCREEN : VIEW_MAP_ONLY;
	} else {
		return (currentView === VIEW_DESKTOP || currentView === VIEW_FULLSCREEN) ? VIEW_DESKTOP : VIEW_MOBILE;
	}
}

/* eslint-disable smells/no-complex-switch-case */
export default memo(
	/**
	 * @param {{}} props
	 * @returns {null}
	 */
	function RouteToStore({}) {
		const dispatch = useDispatch();
		const location = useLocation();
		const history = useHistory();
		const magic = useMagic();
		const view = useSelector(viewSelector);
		//const isMobile = useSelector(createSelector(viewSelector, view => view === VIEW_MOBILE));
		const navPos = navPosition(magic, location.pathname, location.state);

		const appTitle = useSelector(titleSelector);

		console.log('route-to-store',{location, history, magic, view, appTitle, navPos});

		useEffect(
			() => {
				let title = appTitle;

				// TODO Stade -- call setAppTitle somewhere to tell it the SSR code and use details instead of string op on navPos.deepLink
				if(navPos.app) {
					title = navPos.app.title;
					if(navPos.list) {
						title = `${translate('stade.list.heading')} - ${title}`;
					} else if(navPos.listMorePoi) {
						title = `${translate('stade.list.moreHeading')} - ${title}`;
					} else if(navPos.map) {
						title = `${translate('stade.map.heading')} - ${title}`;
					} else if(navPos.deepLink) {
						title = navPos.deepLink.replaceAll('-',' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
					}
				}
				if (typeof window !== 'undefined') {
					const document = window.document;
					document.title = title + ' - Stade Marketing und Tourismus';
				}
			},
			[appTitle, navPos]
		);

		useEffect(
			() => {
				onInit(dispatch);
			},
			// eslint-disable-next-line react-hooks/exhaustive-deps
			[] // leerer Array bedeutet: nur einmal ausführen, kein Array: immer
		);

		// adapt feature sources to change to magic or changed location (this is needed to support deep content pages)
		// Stade: effectivle called only once
		useEffect(
			() => {
				onLoadSourcesOnMagicAppChange(magic, navPos.app? navPos.app.url : '', dispatch);
			},
			[magic, navPos.app?.url, dispatch]
		);

		// Spezialbehandlung content-pages auf mobil
		useEffect(
			() => {
				onMagicLocationViewChange(magic, location.pathname, location.state, view, dispatch);
			},
			[dispatch, magic, view, location.pathname, location.state]
		);

		useEffect(
			() => {
				onMagicLocationChangeWithHistory(magic, location.pathname, location.state, view, history, dispatch);
			},
			[dispatch, history, magic, location.pathname, location.state, view],
		);

		return null;
	}
);

/**
 * @param {import('redux').Dispatch} dispatch
 */
export function onInit(dispatch) {
	// const actions = [];
	//
	// // reset if set by localStorage of user's browser
	// actions.push(setPageTitleShow(false));
	// actions.push(uiSetListFilterControl(false));
	// actions.push(uiSetListSortControl(false));
	//
	// if (typeof window !== 'undefined') {
	// 	const siteId = window.location.hostname.includes('staging') || window.location.hostname.includes('2020') ? 15 : 13;
	// 	// TODO need to set correct values for piwik/matomo urls and siteId
	// 	initTracking('https://stats.vmz-niedersachsen.de/piwik/', siteId, [window.location.hostname], 'https://stats.vmz-niedersachsen.de/piwik/matomo.php');
	// }
	// dispatch(batchActions(actions));
}

/**
 * @param {import('../types').Magic} magic
 * @param {string} appPathName
 * @param {*} locState
 * @param {import('redux').Dispatch} dispatch
 * @param {function(string)=} loadIssue
 */
export function onLoadSourcesOnMagicAppChange(magic, appPathName, dispatch, loadIssue) {
	loadIssue = loadIssue || (id => dispatch(async(load(FEATURE_SOURCES, id))));

	const navPos = appPathName ? navPosition(magic, appPathName) : null;
	// initiate loading of feature source
	if(navPos.app) {
		// TODO load source für Polygon der Route von Stade `${navPos.app.uri}-route`
		const featureSourceUri = navPos.app.uri;
		// dispatch(setListFeatureSource(featureSourceUri)); // TODO check if this load already, check for browser and ssr
		loadIssue(featureSourceUri);
		if (navPos.haveMorePoi) {
			loadIssue(KINDER_POI_URI);
		}
	}
}

/**
 * @param {import('../types').Magic} magic
 * @param {string} locPathName
 * @param {*} locState
 * @param {import('@mapsight/ui/src/js/config/constants/app').View} view
 * @param {import('redux').Dispatch} dispatch
 */
// TODO check ob das für Stade noch passt
export function onMagicLocationViewChange(magic, locPathName, locState, view, dispatch) {
	const isMobile = view === VIEW_MOBILE;

	const navPos = navPosition(magic, locPathName, locState);
	const actions = [
		setListScrollOnPreselection(!isMobile),
	];

	actions.push(setMapVisible(
		true // || navPos.error404 || !navPos.home // Stade abhöngig vom Design eventuell doch sichtbar bei deepLink, also immer
	));
	dispatch(batchActions(actions));
}


// let lastTrackingUrl = null;
// let lastTrackingTitle = null;
let lastPathname = undefined;
let lastPageWasMap = false;

/**
 * @param {import('../types').Magic} magic
 * @param {string} locPathName
 * @param {*} locState
 * @param {string} view
 * @param {object} history
 * @param {import('redux').Dispatch} dispatch
 */
export function onMagicLocationChangeWithHistory(magic, locPathName, locState, view, history, dispatch) {
	const actions = [];
	const navPos = navPosition(magic, locPathName, locState);

	if(navPos.app) {
		setDocumentLanguage(navPos.app.lang);
	}

	// if (navPos.areaChanged) {
	// 	actions.push(animateMap('map', {
	// 		// there's no `nearest` option
	// 		// @ts-ignore
	// 		nearest: true,
	// 		duration: 1000,
	// 		easing: easing.easeOut,
	// 		bounds: navPos.area.bounds,
	// 	}));
	// }


	const mapPage = !!navPos.map;
	const listPage = !!navPos.list || !!navPos.listMorePoi;
	const newView = viewIfMap(mapPage, view);

	if(view !== newView) {
		actions.push(setView(newView));
	}

	actions.push(setListSelectionBehaviorSelection(mapPage || listPage ? FEATURE_SELECTION_PRESELECT : FEATURE_SELECTION_SELECT));
	// // TODO default ist nop aus embed. prüfen wie sich die Karte verhält
	// actions.push(setListSelectionBehavior(
	// 		{
	// 			[VIEW_MOBILE]: mapPage ? 'scrollToMap' : 'nop',
	// 			[VIEW_DESKTOP]: mapPage ? 'scrollToMap' : 'nop',
	// 			[VIEW_MAP_ONLY]: 'scrollToMap',
	// 			[VIEW_FULLSCREEN]: 'scrollToMap'
	// 		}
	// ));
	// TODO default true prüfen
	// actions.push(setListSelectOnClick(specialPage !== SPECIAL_PAGE_PREROUTING));
	// TODO default true prüfen
	// actions.push(setListHighlightOnMouse(specialPage !== SPECIAL_PAGE_PREROUTING));

	// reset ui
	actions.push(setLanguageOpen(false));
	actions.push(setNavigationOpen(false));
	actions.push(setOverlayModalVisible(false));
	// // reset ui, but should not be necessary
	// actions.push(setListSortControl(false));
	// actions.push(setListFilterControl(false));
	// actions.push(setTagSwitcherControl(false));
	actions.push(setListIsVisible(false));
	actions.push(setListVisible(false)); // @mapsight/ui braucht das so. das IsVisible bezieht sich auf die Liste in Fullscree-Lasche, und der default-State von state.list.visible wird ignoriert

	actions.push(setListFeatureSource(navPos.listMorePoi ? KINDER_POI_URI : navPos.app.uri));

	// deselect on all page changes but keep PRESELECTION which is used when switching away from startpage
	// and support deeplinks and select via link state
	if (navPos.deepLink) {
		console.log('route-to-store deepLink bypassing navpos-selection-controller',
			selectExclusivelyFromRoute(FEATURE_SELECTIONS, FEATURE_SELECTION_SELECT, navPos.deepLink)
		);
		actions.push(selectExclusivelyFromRoute(FEATURE_SELECTIONS, FEATURE_SELECTION_SELECT, navPos.deepLink));
	} else if(navPos.home) {
		// select polygon of route TODO Stade: ensure that it is name the like!
		actions.push(selectExclusivelyFromRoute(FEATURE_SELECTIONS, FEATURE_SELECTION_SELECT, `${navPos.app.uri}-route`));
	// } else if (navPos.select) { // dead code for stade ... identical to .deepLink
	// 	actions.push(selectExclusivelyFromRoute(FEATURE_SELECTIONS, FEATURE_SELECTION_SELECT, navPos.select));
	} else {
		console.log('route-to-store deselect bypassing navpos-selection-controller',
			deselectAllFromRoute(FEATURE_SELECTIONS, FEATURE_SELECTION_SELECT)
		);
		actions.push(deselectAllFromRoute(FEATURE_SELECTIONS, FEATURE_SELECTION_SELECT));
	}
	// implizit da dann kein deepLink
	// if (mapPage || navPos.list) {
	// 	actions.push(deselectAllFromRoute(FEATURE_SELECTIONS, FEATURE_SELECTION_PRESELECT));
	// }

	// TODO FIXME STADE Titel anderswo setzen und bei deepLinks, Karte und Liste den poi-Namen inkludieren
	const title = navPos.app?.title || '';
	actions.push(setAppTitle(title));
	// TODO Stade
	// if (typeof window !== 'undefined') {
	// 	if ((locPathName && locPathName !== lastTrackingUrl) || title && title !== lastTrackingTitle) {
	// 		lastTrackingTitle = title;
	// 		lastTrackingUrl = locPathName;
	// 		trackPageView(locPathName, title);
	// 	}
	// }

	if (typeof window !== 'undefined') {
		// TODO prüfen ob nötig oder verbesserungsbedarf. aktuell für wechsel zwischen Deep-Link-Seiten untereinander und von/zur List-Seite
		// TODO nicht scrollen, wenn seitenwechsel von Map-Controls der POI-Seiten ausgelöst wurde → dann aber eine Möglichkeit zum Hochscrollen schaffen, ähnlich wie in Bremen
		if (!lastPageWasMap && !mapPage && lastPathname !== locPathName ) {
			window.scrollTo({top: 0});
		}
		lastPageWasMap = mapPage;
		lastPathname = locPathName;
	}

	dispatch(batchActions(actions));
}

// copied from @neonaut/lib-js only to omit initial 'trackPageView'
// piwik.js is still there, but let's change to matomo.js as we've copied this over already
/**
 * @param {string} piwikURL piwik url
 * @param {number} piwikSiteId piwik site id
 * @param {Array.<string>} piwikDomains domains to track
 * @param {string} [piwikTrackerUrl] piwik tracker url. default: piwikURL + 'piwik.php'
 */
export function initTracking(piwikURL, piwikSiteId, piwikDomains, piwikTrackerUrl) {
	piwikTrackerUrl = piwikTrackerUrl || piwikURL + 'piwik.php';

	if (typeof window === 'undefined') {
		console.log('No Piwik on SSR!');
	}

	window._paq.push(['setDomains', piwikDomains]);
	window._paq.push(['enableLinkTracking']);
	window._paq.push(['enableHeartBeatTimer']);
	window._paq.push(['setTrackerUrl', piwikURL + 'piwik.php']);
	window._paq.push(['setSiteId', piwikSiteId]);
	// window._paq.push(['trackPageView']);

	loadJS(piwikURL + 'matomo.js', () => {
		if (process.env.NN_JS_LOG_LEVEL === 'verbose') {
			if (window.console) {
				console.log('loaded piwik/matomo ', piwikURL, piwikSiteId, piwikDomains, piwikTrackerUrl, window._paq);
			}
		}
	});
}
